module.exports = __webpack_public_path__ + "static/media/  (56).5297bb37.jpg";